'use client';

import { ReactElement } from 'react';
import { UNKNOWN_HOST_DIGEST } from '@provider-directory/types/runtime-config.digest';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const COPY = {
  unknownDirectory: {
    title: 'Directory not recognized',
    description:
      'We couldn’t find a directory for this address. Please check the URL.',
  },
  generic: {
    title: 'Internal server error',
    description: 'Something went wrong on our end. Please try again.',
    reload: 'Reload',
  },
};

const GlobalError = ({ error, reset }: GlobalErrorProps): ReactElement => {
  const isUnknownDirectory = error.digest === UNKNOWN_HOST_DIGEST;
  const copy = isUnknownDirectory ? COPY.unknownDirectory : COPY.generic;

  return (
    <html lang={'en'}>
      <body
        style={{
          margin: 0,
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#143665',
          color: '#ffffff',
          fontFamily:
            'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
          padding: '1.5rem',
        }}
      >
        <main
          style={{
            maxWidth: '40rem',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <h1 style={{ fontSize: '2rem', fontWeight: 600, margin: 0 }}>
            {copy.title}
          </h1>
          <p style={{ fontSize: '1.125rem', margin: 0, opacity: 0.9 }}>
            {copy.description}
          </p>
          {!isUnknownDirectory && (
            <button
              type={'button'}
              onClick={reset}
              style={{
                marginTop: '1rem',
                alignSelf: 'center',
                padding: '0.625rem 1.25rem',
                fontSize: '1rem',
                fontWeight: 500,
                color: '#143665',
                backgroundColor: '#ffffff',
                border: 'none',
                borderRadius: '0.375rem',
                cursor: 'pointer',
              }}
            >
              {COPY.generic.reload}
            </button>
          )}
        </main>
      </body>
    </html>
  );
};

export default GlobalError;
